import type { Typographies } from "@superblocksteam/shared";

export const DEFAULT_RADIO_GROUP_WIDGET_LABEL_TEXT_STYLE_VARIANT: keyof Typographies =
  "inputLabel";
export const DEFAULT_RADIO_GROUP_WIDGET_OPTION_TEXT_STYLE_VARIANT: keyof Typographies =
  "body2";
